import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";

export default function TopicSection() {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <SectionHeading title="精品专题推荐" subtitle="围绕热门话题整理的观影与追剧指南" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {topics.map((t) => (
          <Link
            key={t.id}
            to={t.link}
            className="group block rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <div className="relative w-full aspect-[8/5] overflow-hidden bg-background-200">
              <img
                src={t.cover}
                alt={t.title}
                title={`${t.title} 专题`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent"></div>
              <h3 className="absolute bottom-3 left-4 right-4 font-heading font-bold text-lg text-background-50">
                {t.title}
              </h3>
            </div>
            <p className="p-4 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}